module.exports = {"370672003":"古现街道","370672004":"大季家街道","370672008":"福莱山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370672.json
// module id = 1522
// module chunks = 0